import React, { useMemo } from 'react';

import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import MuiTable, { TableProps as MuiTableProps } from '@material-ui/core/Table';
import classnames from 'classnames';

import TableContext from './TableContext';

const styles = () =>
  createStyles({
    /*
    Styles applied to the root element if `stickyHeader={true}`.
    https://material-ui.com/components/tables/#fixed-header
    */
    stickyHeader: {
      borderCollapse: 'separate',
    },
  });

export interface TableProps extends Omit<MuiTableProps, 'classes'>, WithStyles<typeof styles> {
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE 11.
   */
  stickyHeader?: boolean;
}

const Table: React.FC<TableProps> = ({ classes, className, stickyHeader = false, ...rest }) => {
  const context = useMemo(() => ({ stickyHeader }), [stickyHeader]);

  return (
    <TableContext.Provider value={context}>
      <MuiTable
        className={classnames(className, {
          [classes.stickyHeader]: stickyHeader,
        })}
        {...rest}
      />
    </TableContext.Provider>
  );
};

export default withStyles(styles)(Table);
